module.exports = flarum.core.compat['common/extenders'];